import { api } from "@/shared/api/axios";
import { unwrap } from "@/shared/api/unwrap";
import type { AiTriageResponse } from "@fysaro/types";

interface AnalyzeSymptomInput {
  patientText: string;
  clinicId: string;
}

export async function analyzeSymptom(
  data: AnalyzeSymptomInput,
): Promise<AiTriageResponse> {
  // Tiramos al endpoint público que acabamos de crear en el backend
  const response = await api.post("/ai/public/analyze-symptom", data);
  return unwrap(response.data);
}
